import orderConverter from "../../util/order_converter";
import clickstreamInit from "../../common/clickstream/clickstream-init";
import OrderStatusUpdated from "../../common/clickstream/schemas/order-status-updated-schema";
import sendCSV2Analytics from "../../common/clickstream/send-cs-v2-analytics";
import {
  OrderType,
  STEP_INCREMENT,
  PREP_TIME_MIN_MAX,
} from "./foodPrepTimeConstants";
import {
  getFormattedPrepTime,
  getStepperChangedMinsText,
  getStepperConfirmText,
  getStepperHaveReadyText,
  getStepperHeaderText,
} from "./foodPrepTimeHelpers";

class FoodPrepTimeController {
  constructor($location, foodPrepTimeService) {
    this.$location = $location;
    this.foodPrepTimeService = foodPrepTimeService;
  }

  $onInit() {
    const params = this.$location.search();
    this.orderType = params.orderType;
    this.initialPrepMins = parseInt(params.foodPrepDefault);
    this.prepMins = this.initialPrepMins;
    this.min = PREP_TIME_MIN_MAX[this.orderType].min;
    this.max = PREP_TIME_MIN_MAX[this.orderType].max;

    if (!this.areInitialValuesValid()) {
      this.$location.url("/error");
    }

    this.showErrorMessage = false;

    clickstreamInit();
  }

  areInitialValuesValid() {
    const isOrderTypeValid = Object.values(OrderType).includes(this.orderType);
    const isInitialPrepMinsValid = Number.isInteger(this.initialPrepMins);
    return isOrderTypeValid && isInitialPrepMinsValid;
  }

  get formattedFoodPrepTime() {
    return getFormattedPrepTime(this.prepMins);
  }

  get stepperHeaderText() {
    return getStepperHeaderText(this.orderType);
  }

  get stepperChangedMinsText() {
    return getStepperChangedMinsText({
      orderType: this.orderType,
      prepMins: this.prepMins,
      initialPrepMins: this.initialPrepMins,
    });
  }

  get stepperHaveReadyText() {
    return getStepperHaveReadyText(this.orderType);
  }

  get stepperConfirmText() {
    return getStepperConfirmText(this.orderType, this.prepMins);
  }

  get decrementedPrepMins() {
    return this.prepMins - STEP_INCREMENT;
  }

  get incrementedPrepMins() {
    return this.prepMins + STEP_INCREMENT;
  }

  get isDecrementEnabled() {
    return this.min < this.prepMins;
  }

  get isIncrementEnabled() {
    return this.max > this.prepMins;
  }

  handleDecrementPrepMins() {
    this.prepMins = this.decrementedPrepMins;
  }

  handleIncrementPrepMins() {
    this.prepMins = this.incrementedPrepMins;
  }

  postOrderStatusUpdatedAnalytics() {
    return sendCSV2Analytics(OrderStatusUpdated, {
      confirmedOrder: this.foodPrepTimeService.getConfirmedOrder(),
      initialPrepMins: this.initialPrepMins,
      prepMins: this.prepMins,
    });
  }

  handleStepperConfirmSuccess(response) {
    const convertedOrder = orderConverter.convert(response.data);
    this.foodPrepTimeService.setConfirmedOrder(convertedOrder);

    this.postOrderStatusUpdatedAnalytics();
    this.goToConfirmedPage();
  }

  handleStepperConfirmFailure() {
    this.showErrorMessage = true;
  }

  handleStepperConfirm() {
    return this.foodPrepTimeService
      .postOrderConfirm(this.prepMins)
      .then((response) => this.handleStepperConfirmSuccess(response))
      .catch(() => this.handleStepperConfirmFailure());
  }

  goToConfirmedPage() {
    this.$location.url("/confirmed");
  }
}

FoodPrepTimeController.$inject = ["$location", "foodPrepTimeService"];

export default FoodPrepTimeController;



// WEBPACK FOOTER //
// ./client/app/components/foodPrepTime/foodPrepTime.controller.js